import { Signal } from '@angular/core'

import { ContainerInfo } from '../container-info'

/**
 * a marker class also used as interface where implemented
 */
export abstract class LayoutContainer {
  readonly containerInfo: Signal<ContainerInfo>
}
